<template>
    <div :class="'relative w-full ' + ' ' + wrapperCssClasses">
        <label
            v-if="label && labelPosition == 'top'"
            :for="id"
            :class="'mb-2 block font-semibold' + ' ' + labelClasses"
        >
            <span v-html="label"></span>
        </label>

        <div class="relative flex w-full items-center">
            <label
                v-if="label && labelPosition == 'inside' && modelValue"
                :for="id"
                :class="
                    'text-gray-1700 absolute left-4 top-2 z-20 text-[12px] ' +
                    labelClasses
                "
            >
                <span v-html="label"></span>
            </label>

            <input
                :id="id"
                :name="name"
                :ref="id"
                :class="
                    themedCssClasses +
                    (disabled
                        ? ' cursor-not-allowed border-gray-400 bg-gray-50 text-gray-500'
                        : '') +
                    ($page.props.errors[name] ? ' border-red-400' : '')
                "
                :type="type"
                :value="modelValue"
                @input="updateInput"
                :disabled="disabled"
                :required="required"
                :autocomplete="autoComplete"
                :placeholder="this.placeholder ?? this.label"
            />

            <form-error-warning-triangle :name="name"/>
        </div>

        <field-error
            v-if="!hideErrors"
            :field-name="label"
            :message="$page.props.errors[name]"
        />

        <div class="mb-3 text-[12px] text-gray-700" v-if="hint">
            {{ hint }}
        </div>
    </div>
</template>

<script>
import FieldError from "@/Components/FieldError";
import FormErrorWarningTriangle from "@/Components/FormErrorWarningTriangle";

export default {
    name: "FormInput",
    components: {
        FormErrorWarningTriangle,
        FieldError,
    },
    props: {
        id: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        hint: {
            type: String,
            default: "",
        },
        name: {
            type: String,
            default: null,
        },
        placeholder: {
            type: [String, Number],
            default: null,
        },
        modelValue: {
            type: [String, Number],
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: "text",
        },
        wrapperCssClasses: {
            type: String,
            default: "",
        },
        labelClasses: {
            type: String,
            default: "block text-[14px]",
        },
        labelPosition: {
            type: String,
            default: "top",
        },
        cssClasses: {
            type: String,
            default: "",
        },
        autoComplete: {
            type: String,
            default: null,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        hideErrors: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        updateInput(event) {
            this.$emit("update:modelValue", event.target.value);
        },
    },
    mounted() {
        if (this.autofocus) {
            // document.getElementById(this.id).focus();
        }
    },
    computed: {
        themedCssClasses() {
            let css = "appearance-none ";

            if (this.labelPosition == "inside") {
                css += "w-full p-1 pl-3 pt-6 pr-12 ";
            } else {
                css += "w-full p-2 pr-12 ";
            }

            css += " " + this.cssClasses;

            return css;
        },
    },
};
</script>
